import jwtDecode from 'jwt-decode';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import react,{useState, useEffect} from  'react';
import { useSearchParams } from 'react-router-dom';
import { AntInput } from '../../../shared/widges/antinput';
import { WtButton } from "../../../shared/widges/Button/button";
import { GetItemFromStorage } from '../../../custom_hooks/useStorage';
import { LocalStorage } from '../../../custom_hooks/localStorageKeys';
import { useDispatcher } from '../../../custom_hooks/use_app_dispatch';
import { getWebChatwidgetDetails } from '../../../store/api/chat_call_Sessions';
import {Switch, Select, notification} from 'antd';
import { ConnectorService } from '../../../base/service/apiServices';
import _ from 'lodash';

type wixOauthConnectState = {
    siteInfoData :any,
    ecomConnectionName: string,
    ecomWidget : boolean,
    selectedBotData: any,
    isNewConnection : boolean,
    prevConStore : any,
    botselect : boolean,
    disableConnect : boolean
}

 const WixOauthConnect = ()=> {

    const dispatch: any = useDispatcher();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const wixQuery: any = searchParams.get("wix_code");
    
    const wixLocalEncrypt: any = sessionStorage.getItem(LocalStorage.WIX_CRED);
    
    const loginUserCcaasDetail = GetItemFromStorage(LocalStorage.USER_DETAILS);
    const chatConfiguration: any = useSelector((state: any) => state.chatConfiguration);
    const getStoreDetails: any = useSelector((state: any) => state.connectors.storeDetails);
    const widgetList: any = chatConfiguration.apiData;



    const [getWixinfo, setWixInfo]  = useState<wixOauthConnectState>({
        siteInfoData :  {}, ecomConnectionName: '',   ecomWidget :  false,
        selectedBotData: {
            title: '',
            webChatId: ''
        },
        isNewConnection : false,
        prevConStore : {},
        botselect : false,
        disableConnect : false
    })

     

    const wixTokenDecrypt =async()=> {

        if (!(wixQuery || wixLocalEncrypt)) {
            navigate('/connectors');
        }

        let encryptedToken = wixQuery ?? wixLocalEncrypt;
      
        let decodeToken = jwtDecode(encryptedToken);
       
        getInstalledStoreData(decodeToken);

    }
    
    const handleConectionName = (e:any)=> {
        
        setWixInfo({...getWixinfo, ecomConnectionName: e.target.value });
        
    }

    const wixStoreConnectUpdate = async () => {
        setWixInfo({ ...getWixinfo, disableConnect: true })
        const { ecomConnectionName, isNewConnection, selectedBotData, ecomWidget, prevConStore } = getWixinfo;

        if (!ecomConnectionName || ecomConnectionName.length < 5) {
            notification.info({
                message: 'Please Enter connection name or name should be maximum 5 characters',
                placement: "topRight",
                className: 'toastNotification error',
                icon: <span className="icon__Warning24" />,
                closeIcon: <span className="icon__IconCloseNew16" />,
                duration: 3,
                top: 70,
            });
            return true;
        }

        const payload = {
            "domainId": loginUserCcaasDetail.domainId,
            "connectionName": ecomConnectionName,
            "botData": selectedBotData,
            "chatWidgetStatus": (ecomWidget && selectedBotData.webChatId) ? true : false,
            "scriptId": prevConStore.scriptId ?? '',
           
            
        }
        const token = !isNewConnection ? prevConStore.token : (wixQuery ?? wixLocalEncrypt);
        const endpoint = `wix/v1/connection`;

        await ConnectorService.post(endpoint, payload ,token).then(async (response: any) => {
           
            if (response.statusCode === 200) {
                notification.info({
                    message: "Connection Established Successfully",
                    placement: "topRight",
                    className: "toastNotification success",
                    icon: <span className="icon__Success24" />,
                    closeIcon: <span className="icon__IconCloseNew16" />,
                    duration: 3,
                    top: 70,
                });
                
                sessionStorage.removeItem(LocalStorage.WIX_CRED);
                navigate('/wixconnectionlist');
               
            }
        }).catch((err) => {
            console.log("error in Wix connection----", err);
        })
    }


   
    const setToggleFunc = (e:any) => {
        setWixInfo({...getWixinfo,ecomWidget:e})
    }

    const getInstalledStoreData = async (authData: any) => {
        try {
            let { isNewConnection, ecomConnectionName, ecomWidget, selectedBotData } = getWixinfo;
            let endpoint: any = `common/v1/stores/installed`;
            let payload = {
                domainId: loginUserCcaasDetail.domainId,
                store:   authData.siteName ?? ''
            }

          

            await ConnectorService.post(endpoint, payload, '').then((response: any) => {

                if (response.statusCode === 200) {
                    isNewConnection = _.isEmpty(response.result) ? true : false;
                    ecomConnectionName = response.result.connectionName ?? '';
                    ecomWidget = response.result?.chatWidgetStatus == '1' ? true : false;
                    selectedBotData = !_.isEmpty(response.result) ? JSON.parse(response.result.botData) : {
                        title: '',
                        webChatId: ''
                    };
                    response.result = !_.isEmpty(response.result) && { ...response.result, botData: JSON.parse(response.result.botData) }

                    setWixInfo({
                        ...getWixinfo, isNewConnection: isNewConnection, prevConStore: response.result, ecomConnectionName: ecomConnectionName, ecomWidget: ecomWidget, selectedBotData: selectedBotData, disableConnect :false , siteInfoData : authData
                    });
                }
                else {
                    console.log('GetInstalledStoregeError');
                }
            })


        } catch (error) {
            console.log("get installed store",error)
        }
    }



    const handleBotWidget = (e: any) => {
        let parsedBotData = JSON.parse(e);
       
        setWixInfo({
            ...getWixinfo, botselect: false, selectedBotData: {
                ...getWixinfo.selectedBotData, title: parsedBotData.title, webChatId: parsedBotData.webchatid
            }
        });
    };


    
    const checkConnectButton = () => {
        let { ecomConnectionName, prevConStore, disableConnect, selectedBotData } = getWixinfo;

        let isChecked = false;
        if (ecomConnectionName.length < 5 || disableConnect){
            isChecked = true;
        }
        else if ((ecomConnectionName === prevConStore?.connectionName && selectedBotData.title === prevConStore?.botData?.title)) {
            isChecked = true;
        }
        return isChecked;
    }



    useEffect(()=>{
        wixTokenDecrypt();
        dispatch(getWebChatwidgetDetails());
    },[])

    
    return (
        <>
           <div className="mainboglayout">
                <div className="mainbigcommerce">
                    <div className="bigcommerces">
                        <div className="biglogo">
                            <svg xmlns="http://www.w3.org/2000/svg" width="175" height="40" viewBox="0 0 175 40" fill="none">
                                <path d="M39.733 7.45349V26.7415H26.4591V20.7834C26.4591 16.7926 23.2346 13.5542 19.2595 13.5542H13.3271V0.222656H32.5334C36.5085 0.222656 39.733 3.45953 39.733 7.45349Z" fill="#e6e4eb" />
                                <path d="M26.4587 26.7383V39.9193L13.333 26.7383H26.4587Z" fill="#e6e4eb" />
                                <path d="M26.4588 20.7801C26.4588 16.7877 23.2359 13.5508 19.2607 13.5508H13.3284L13.3331 13.5555H0.208984V26.7365H13.3331V13.5571L26.4572 26.7381V20.7801H26.4588Z" fill="black" />
                                <path d="M71.9694 8.45703L68.6607 20.4452L65.6001 8.89279H60.264L57.2035 20.4452L53.8323 8.45703H48.3276L54.7282 31.4396H58.8094L62.9313 19.6066L67.022 31.4396H71.1345L77.535 8.45703H71.9694ZM82.9382 15.6628C78.5463 15.6628 74.9598 19.2649 74.9598 23.6758C74.9598 28.0867 78.5463 31.6888 82.9382 31.6888C87.3301 31.6888 90.9166 28.0867 90.9166 23.6758C90.9166 19.2649 87.3301 15.6628 82.9382 15.6628ZM82.9382 26.6572C81.2994 26.6572 79.9697 25.3217 79.9697 23.6758C79.9697 22.0299 81.2994 20.6944 82.9382 20.6944C84.577 20.6944 85.9067 22.0299 85.9067 23.6758C85.9067 25.3217 84.577 26.6572 82.9382 26.6572ZM124.918 10.9729H119.909V24.8859C119.909 29.4207 122.197 31.438 126.186 31.438H129.123V26.4064H126.34C125.474 26.4064 124.918 25.7857 124.918 24.947V20.2885H129.31V15.9089H124.918V10.9713V10.9729ZM163.974 15.9105H159.768V16.6252C158.593 16.0029 157.357 15.6612 155.996 15.6612C151.605 15.6612 148.05 19.232 148.05 23.6429C148.05 28.0538 151.605 31.6873 155.996 31.6873C157.417 31.6873 158.655 31.2828 159.83 30.6919V31.438H164.945V26.8892H163.974V15.9105ZM156.117 26.6556C154.48 26.6556 153.18 25.3201 153.18 23.6429C153.18 21.9657 154.479 20.66 156.117 20.66C157.756 20.66 159.087 21.9955 159.087 23.6429C159.087 25.2903 157.758 26.6556 156.117 26.6556ZM173.159 26.4064C172.416 26.4064 172.044 25.9095 172.044 25.1947V9.70005H166.065V14.2489H167.036V25.1336C167.036 29.5131 168.612 31.438 173.004 31.438H174.209V26.4064H173.157H173.159ZM96.3058 16.6237V15.9089H91.5019V20.4577H92.4726V31.4365H97.4201V22.4924C97.4201 21.4688 98.2567 20.66 99.2758 20.66H101.316V15.9089H99.0901C98.1303 15.9089 97.2032 16.0641 96.3058 16.6237ZM118.356 15.9089H112.419L108.192 20.0392V9.70005H102.215V14.2489H103.184V31.438H108.194V26.9973L109.166 26.0506L113.069 31.438H119.13L112.512 22.6805L118.356 15.9105V15.9089ZM141.368 24.8216C141.368 25.8468 140.533 26.6854 139.513 26.6854C138.492 26.6854 137.659 25.8452 137.659 24.8216V15.9089H131.708V20.4577H132.682V24.8216C132.682 28.6103 135.742 31.6857 139.514 31.6857C143.287 31.6857 146.349 28.6103 146.349 24.8216V15.9089H141.37V24.8216H141.368Z" fill="black" />
                            </svg>
                        </div>
                        <div className="connectionname">
                            <label> Connection name</label>
                            <span>Store Name</span>
                            <span>{getWixinfo.siteInfoData?.siteName}</span>
                            <AntInput
                                className="textBox active"
                                placeHolder="Enter Connection name"
                                autoFocus={true}
                                maxLength={45}
                                value={getWixinfo.ecomConnectionName}
                                onChange={(e:any)=> handleConectionName(e)}
                            />
                        </div>

                        <div className="connectionnameswitch">
                            <p>Installing Worktual chatbox will enable you to set up the chatbox on your website.</p>
                            <Switch size="small" checked={getWixinfo.ecomWidget} onChange={(e) => setToggleFunc(e)} />
                        </div>

                        {(getWixinfo.ecomWidget) &&
                            <div className="configurewidget">
                                <h4>Configure Widget</h4>
                                <label> Select Your widget</label>
                                <Select
                                    showSearch={true}
                                    placeholder="Select Your Widget"
                                    className="antSelect selectcloseicon"
                                    popupClassName="antSelectPopover tickrightremove"
                                    value={getWixinfo.selectedBotData.title || undefined}
                                    onChange={handleBotWidget}
                                    suffixIcon={<span className="icon__Downarrow16"></span>}>
                                    {widgetList.map((data: any, index: any) => {
                                        return <Select.Option key={index} value={JSON.stringify(data)}>{data.title}</Select.Option>
                                    })}
                                </Select>

                                <div className="widgetbtn">
                                    <WtButton name={(getWixinfo.selectedBotData.webChatId && getWixinfo.botselect) ? "selected" : "select widget"} className={(getWixinfo.selectedBotData.webChatId && getWixinfo.botselect) ? "buttonSave disabled" : "buttonSave"} onClick={() => { setWixInfo({ ...getWixinfo, botselect: true }) }} />
                                </div>
                            </div>
                        }

                        <div className="bigcommercebutton">
                            <WtButton name="Cancel" className="buttonCancel" onClick={() => navigate('/connectors')} />
                            <WtButton name={getWixinfo.isNewConnection ? "Connect" : "Update"} className={checkConnectButton() ? "buttonSave disabled" : "buttonSave"} onClick={wixStoreConnectUpdate} />
                        </div>
                        
                    </div>
                </div>
    
            </div>
        </>
    )
}

export default WixOauthConnect;